<template>
  <div class="outline-container">
    <div class="outline-content">
      <div class="outline-main">
        <div class="outline-tree">
          <el-tree :data="outlineData" node-key="title" default-expand-all :expand-on-click-node="false"
            :draggable="true" :allow-drop="allowDrop" @node-drop="handleNodeDrop" @node-drag-over="handleDragOver"
            @node-drag-start="handleDragStart" class="custom-tree">
            <span class="custom-tree-node" slot-scope="{ data }">
              <span class="node-content" :class="{ 'node-with-dot': !data.children || !data.children.length }">
                <div v-if="data.label" class="node-label">
                  {{ data.label }}
                </div>
                <div v-if="data.isEditing" style="width: 100%;">
                  <el-input v-model="data.title" class="normal-input" ref="editInput" @input="handleNodeEdit(data)"
                    @keyup.enter.native="saveNodeEdit(data)" v-focus></el-input>
                </div>
                <div v-else class="node-title">{{ data.title }}</div>
              </span>
              <div class="node-actions">
                <el-tooltip content="编辑节点" placement="top">
                  <el-button type="text" class="icon-button" @click="(e) => editNode(data, e)">
                    <img src="@/assets/images/icon-outline-edit.png" alt="编辑节点" class="action-icon">
                  </el-button>
                </el-tooltip>
                <el-tooltip content="新增子节点" placement="top">
                  <el-button type="text" class="icon-button" @click="addNode(data)">
                    <img src="@/assets/images/icon-outline-add.png" alt="新增子节点" class="action-icon">
                  </el-button>
                </el-tooltip>
                <el-tooltip content="删除节点" placement="top">
                  <el-button type="text" class="icon-button" @click="delNode(data)">
                    <img src="@/assets/images/icon-outline-remove.png" alt="删除节点" class="action-icon">
                  </el-button>
                </el-tooltip>
              </div>
            </span>
          </el-tree>
        </div>
        <el-button type="primary" class="generate-button" round @click="handleGenerate">
          生成标准
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';

export default {
  name: 'Outline',
  props: {
    outlineData: {
      type: Array,
      default: () => []
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.querySelector('input').focus();
      }
    }
  },
  data() {
    return {
      activeTab: 'theme',
      currentEditingNode: null,
      selectionStart: 0,
      selectionEnd: 0,
      dragSourceParent: null
    }
  },
  mounted() {
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    // 处理点击其他区域的情况
    handleOutsideClick(event) {
      // 如果当前有正在编辑的节点
      if (this.currentEditingNode) {
        // 检查点击是否在输入框外部
        const editInputs = this.$refs.editInput;
        if (editInputs) {
          const isClickOutside = Array.isArray(editInputs)
            ? !editInputs.some(input => input.$el.contains(event.target))
            : !editInputs.$el.contains(event.target);

          // 如果点击在输入框外部，并且不是点击的编辑按钮
          if (isClickOutside && !event.target.closest('.icon-button')) {
            this.saveNodeEdit(this.currentEditingNode);
          }
        }
      }
    },
    addNode(data) {
      console.log(data);
      const newNode = {
        title: '新节点'
      };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newNode);
    },
    delNode(data) {
      MessageBox.confirm(`确定删除当前节点（${data.title}）及其所有子节点？`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const removeNode = (nodes, target) => {
          for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            if (node === target) {
              nodes.splice(i, 1);
              return true;
            }
            if (node.children && removeNode(node.children, target)) {
              return true;
            }
          }
          return false;
        };

        if (removeNode(this.outlineData, data)) {
          console.log('节点已删除:', data);
        } else {
          console.log('未找到节点:', data);
        }
      }).catch(() => {
        console.log('删除操作已取消');
      });
    },
    editNode(data, event) {
      // 如果当前有正在编辑的节点，先保存它
      if (this.currentEditingNode && this.currentEditingNode.isEditing) {
        this.saveNodeEdit(this.currentEditingNode);
      }

      // 设置当前节点为编辑模式
      this.$set(data, 'isEditing', true);
      this.currentEditingNode = data;

      // 阻止事件冒泡，防止立即触发外部点击事件
      if (event) {
        event.stopPropagation();
      }
    },
    handleNodeEdit() {
      // 保存当前光标位置
      if (document.activeElement && document.activeElement.tagName === 'INPUT') {
        this.selectionStart = document.activeElement.selectionStart;
        this.selectionEnd = document.activeElement.selectionEnd;
      }

      this.$nextTick(() => {
        const inputs = this.$refs.editInput;
        if (Array.isArray(inputs)) {
          // 如果是多个引用，找到当前正在编辑的那个
          const activeInput = inputs.find(el => el.$el.contains(document.activeElement));
          if (activeInput) {
            activeInput.focus();
            // 恢复光标位置
            activeInput.$el.querySelector('input').setSelectionRange(this.selectionStart, this.selectionEnd);
          }
        } else if (inputs) {
          inputs.focus();
          // 恢复光标位置
          inputs.$el.querySelector('input').setSelectionRange(this.selectionStart, this.selectionEnd);
        }
      });
    },
    saveNodeEdit(data) {
      // 退出编辑模式
      this.$set(data, 'isEditing', false);
      this.currentEditingNode = null;
      console.log('节点已保存:', data.title);
    },
    exitAllEditMode() {
      const traverseNodes = (nodes) => {
        nodes.forEach(node => {
          if (node.isEditing) {
            this.$set(node, 'isEditing', false);
          }
          if (node.children) {
            traverseNodes(node.children);
          }
        });
      };

      traverseNodes(this.outlineData);
      this.currentEditingNode = null;
    },
    handleGenerate() {
      // 确保所有编辑都已保存
      this.exitAllEditMode();

      this.$nextTick(() => {
        this.$emit('generate')
      })
    },
    getChildrenWithLabel(children) {
      return children ? children.filter(child => child.label) : []
    },
    /* -------- 拖拽排序相关 -------- */
    // 控制允许放置的位置，上下以及作为子节点均允许
    allowDrop(draggingNode, dropNode, type) {
      // 引用参数避免未使用警告
      void draggingNode;
      void dropNode;
      void type;
      // 始终允许拖拽到前、后或作为子节点
      return true;
    },

    handleDragOver(draggingNode, dropNode, e) {
      // 根据放置类型修改鼠标指针样式
      if (dropNode && dropNode.dropType === 'inner') {
        e.dataTransfer.dropEffect = 'copy'; // 显示为添加状态
      } else {
        e.dataTransfer.dropEffect = 'move'; // 显示为移动状态
      }
    },

    // 拖拽释放后触发
    handleNodeDrop(draggingNode, dropNode, dropType) {
      void dropNode; // 避免未使用警告
      void dropType;
      // 拖拽的节点数据
      const dragged = draggingNode.data;

      // 根据新的兄弟节点信息更新序号
      this.$nextTick(() => {
        // 获取所在的兄弟节点数组
        const siblings = this.getSiblingsArray(dragged);
        if (!siblings) return;

        // 找到拖拽后所在的索引
        const newIndex = siblings.indexOf(dragged);
        if (newIndex === -1) return;

        // 判断前一个兄弟节点是否有序号
        const prevSibling = siblings[newIndex - 1];

        const prevInfo = prevSibling ? this.extractNumberInfo(prevSibling.title) : null;

        let delimiter = prevInfo ? prevInfo.delimiter : '.';
        let startNumber = prevInfo ? prevInfo.lastNumber + 1 : null;
        let prefixNumbers = prevInfo ? prevInfo.numbers.slice(0, -1) : [];

        if (startNumber !== null) {
          // 更新当前及其后续兄弟节点的序号
          this.updateNumbers(siblings, newIndex, startNumber, delimiter, prefixNumbers);
        } else {
          // 无前一个兄弟节点，或其无有效序号——从父节点推导起始序号 1
          const parent = this.getParentNode(dragged);
          if (parent) {
            const parentInfo = this.extractNumberInfo(parent.title);
            if (parentInfo) {
              const pDelimiter = parentInfo.delimiter || '.';
              const prefixes = parentInfo.numbers;

              // 更新当前及其后续兄弟节点
              this.updateNumbers(siblings, newIndex, 1, pDelimiter, prefixes);
            }
          }
        }

        // 拖拽节点自身序号更新后，若存在子节点则递归重排其子节点序号
        this.updateChildrenNumbers(dragged);

        // 若源父节点存在，则对其剩余子节点重新排序，避免出现空号
        if (this.dragSourceParent) {
          this.updateChildrenNumbers(this.dragSourceParent);
        } else {
          // 根层拖拽，也需要整体检查根层排序
          this.updateChildrenNumbers({ children: this.outlineData, title: '' });
        }

        // 清空记录
        this.dragSourceParent = null;
      });
    },

    // 取得节点的父级数组引用（兄弟节点列表）
    getSiblingsArray(node) {
      const traverse = (nodes, parent = null) => {
        for (let i = 0; i < nodes.length; i++) {
          const n = nodes[i];
          if (n === node) {
            return parent ? parent.children || parent : this.outlineData;
          }
          if (n.children) {
            const res = traverse(n.children, n);
            if (res) return res;
          }
        }
        return null;
      };
      return traverse(this.outlineData);
    },

    // 获取节点的父节点对象
    getParentNode(node) {
      const search = (nodes, parent = null) => {
        for (let n of nodes) {
          if (n === node) return parent;
          if (n.children) {
            const res = search(n.children, n);
            if (res) return res;
          }
        }
        return null;
      };
      return search(this.outlineData);
    },

    // 提取标题中的序号信息，支持多级序号（如 1.2.3）以及"1范围"无分隔符格式
    extractNumberInfo(title) {
      const str = String(title).trim();
      // 捕获数字部分（可含 . 分级）、可能存在的分隔符（. 或 、），以及后续文本
      const match = str.match(/^(\d+(?:\.\d+)*)([.、]?)(.*)$/);
      if (!match) return null;

      const numbersPart = match[1];
      const afterDelimiterChar = match[2]; // 可能为空
      const text = match[3].trim();

      // 如果数字串本身包含 '.'，则默认分级符号为 '.'
      // 否则采用捕获的分隔符；若仍为空，说明根级无显式分隔符
      const delimiter = numbersPart.includes('.') ? '.' : (afterDelimiterChar || '');

      const numbersArr = numbersPart.split('.').map(n => parseInt(n, 10));

      return {
        numbers: numbersArr,      // 数字数组，如 [4,1]
        lastNumber: numbersArr[numbersArr.length - 1],
        delimiter,               // '.', '、' 或 ''
        text,                    // 序号后的正文
      };
    },

    // 去除序号前缀（兼容无显式分隔符场景）
    stripNumberPrefix(title) {
      const m = String(title).trim().match(/^\d+(?:\.\d+)*[.、]?\s*(.*)$/);
      return m ? m[1] : title;
    },

    // 从指定索引开始按顺序更新序号
    // prefixNumbers: 上级数字数组（不含需要更新的最后一个数字）
    updateNumbers(siblings, startIdx, startNumber, delimiter, prefixNumbers = []) {
      let currentNumber = startNumber;
      for (let i = startIdx; i < siblings.length; i++) {
        const n = siblings[i];

        // 如果该节点本身无数字前缀，则跳过，不参与排序
        const info = this.extractNumberInfo(n.title);
        if (!info) {
          continue;
        }

        const text = this.stripNumberPrefix(n.title);

        let newPrefix = '';
        if (delimiter === '、') {
          newPrefix = currentNumber + '、';
        } else {
          if (prefixNumbers.length) {
            newPrefix = [...prefixNumbers, currentNumber].join('.');
          } else {
            newPrefix = delimiter === '.' ? currentNumber + '.' : String(currentNumber);
          }
        }

        n.title = newPrefix + ' ' + text;

        // 递归调整子节点
        if (n.children && n.children.length) {
          this.updateChildrenNumbers(n);
        }

        currentNumber++; // 仅在成功更新后递增
      }
    },

    // 根据父节点的新序号，递归更新所有子节点序号
    updateChildrenNumbers(parentNode) {
      if (!parentNode.children || !parentNode.children.length) return;

      const parentInfo = this.extractNumberInfo(parentNode.title);
      if (!parentInfo) return;

      const prefixes = parentInfo.numbers; // 完整父级数字数组
      const delimiter = parentInfo.delimiter === '、' ? '、' : '.';

      let seq = 1;
      parentNode.children.forEach((child) => {
        // 若无数字前缀，跳过重新排序
        const info = this.extractNumberInfo(child.title);
        if (!info) {
          return;
        }

        const text = this.stripNumberPrefix(child.title);
        let newPrefix;

        if (delimiter === '、' && prefixes.length === 0) {
          newPrefix = seq + '、';
        } else {
          newPrefix = [...prefixes, seq].join('.');
        }

        child.title = newPrefix + ' ' + text;

        seq++;

        // 递归处理下一级
        this.updateChildrenNumbers(child);
      });
    },

    handleDragStart(draggingNode) {
      // 记录源父节点数据引用（可能为 null 表示根层）
      this.dragSourceParent = draggingNode.parent ? draggingNode.parent.data : null;
    },
  }
}
</script>

<style scoped>
.outline-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  margin-top: 20px;
  margin-bottom: 20px;
}

.outline-header {
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}

.progress {
  margin-top: 10px;
  position: relative;
}

.progress-text {
  position: absolute;
  right: 0;
  top: -20px;
  font-size: 14px;
  color: #7e57c2;
}

.outline-content {
  display: flex;
  min-height: 600px;
}

.outline-nav {
  width: 60px;
  border-right: 1px solid #ebeef5;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
}

.nav-label {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  color: #606266;
  font-size: 12px;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin: 0 10px;
  background-color: #f5f7fa;
  transition: all 0.3s;
}

.nav-label:hover {
  border-color: #7e57c2;
  color: #7e57c2;
  background-color: #f0e6ff;
}

.sub-label {
  margin-left: 20px;
  height: 30px;
  font-size: 11px;
  margin-top: -10px;
}

.outline-main {
  flex: 1;
  padding: 20px;
  min-width: 0;
}

.outline-tree {
  padding: 0 20px;
  width: 100%;
}

.custom-tree {
  font-size: 14px;
  width: 100%;
}

.custom-tree>>>.el-tree-node {
  position: relative;
  width: 100%;
}

.custom-tree>>>.el-tree-node__content {
  height: 40px;
  display: flex;
  align-items: center;
  padding-right: 20px;
  width: 100%;
  box-sizing: border-box;
}

.custom-tree>>>.el-tree-node__children {
  padding-left: 0;
  width: 100%;
}

.node-content {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  min-width: 0;
  cursor: move;
}

.node-label {
  margin-right: 10px;
  border: 1px solid #7e57c2;
  padding: 3px 5px;
  border-radius: 5px;
  color: #7e57c2;
  flex-shrink: 0;
}

.node-with-dot::before {
  content: '';
  position: absolute;
  left: -24px;
  width: 8px;
  height: 8px;
  border: 2px solid #ddd;
  border-radius: 50%;
  background: #fff;
}

.theme-label {
  color: #303133;
  font-weight: bold;
}

.catalog-label {
  color: #303133;
}

.normal-label {
  color: #606266;
}

.custom-tree>>>.el-tree-node__expand-icon.expanded {
  transform: rotate(90deg);
}

.custom-tree>>>.el-tree-node.is-expanded>.el-tree-node__content .el-tree-node__expand-icon {
  color: #909399;
}

/* 添加垂直连接线 */
.custom-tree>>>.el-tree-node::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 20px;
  width: 1px;
  height: calc(100% - 20px);
  background-color: #ddd;
}

.custom-tree>>>.el-tree-node:last-child::before {
  height: 20px;
}

/* 添加水平连接线 */
.custom-tree>>>.el-tree-node::after {
  content: '';
  position: absolute;
  left: -12px;
  top: 20px;
  width: 12px;
  height: 1px;
  background-color: #ddd;
}

/* 添加输入框样式 */
.normal-input {
  width: 100% !important;
}

.theme-input>>>.el-input__inner,
.normal-input>>>.el-input__inner {
  border: none;
  background-color: transparent;
  padding: 0;
  height: 24px;
  line-height: 24px;
  width: 100%;
  min-width: 300px;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.theme-input>>>.el-input__inner {
  font-weight: bold;
  color: #303133;
}

.normal-input>>>.el-input__inner {
  color: #606266;
  padding: 0 8px;
}

.theme-input>>>.el-input__inner:hover,
.normal-input>>>.el-input__inner:hover {
  background-color: #f5f7fa;
  box-shadow: 0 0 0 1px #999999 inset;
}

.theme-input>>>.el-input__inner:focus,
.normal-input>>>.el-input__inner:focus {
  background-color: #f5f7fa;
  box-shadow: 0 0 0 1px #999999 inset;
}

/* 添加输入框右侧编辑图标 */
.theme-input>>>.el-input__suffix,
.normal-input>>>.el-input__suffix {
  right: 0;
  color: #7e57c2;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.theme-input:hover>>>.el-input__suffix,
.normal-input:hover>>>.el-input__suffix,
.theme-input>>>.el-input__suffix.is-focus,
.normal-input>>>.el-input__suffix.is-focus {
  opacity: 1;
}

/* 修改输入框宽度以适应内容 */
.node-content .el-input {
  flex: 1;
  min-width: 0;
  width: auto;
  position: relative;
}

.generate-button {
  display: block;
  margin: 20px auto;
  box-sizing: border-box;
  padding: 0 20px;
  font-size: 18px;
  height: 52px;
  min-width: 159px;
  line-height: 52px;
  background: linear-gradient(270deg, #8F9EFF 0%, #4E1AD6 100%);
  border-radius: 43px;
  border: none;
}

.generate-button:hover {
  background: linear-gradient(270deg, #8F9EFF 0%, #4E1AD6 100%);
  opacity: 0.9;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.node-actions {
  display: flex;
  gap: 5px;
  opacity: 0;
  transition: opacity 0.3s;
}

.custom-tree-node:hover .node-actions {
  opacity: 1;
}

.icon-button {
  padding: 0;
  margin: 0;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-icon {
  width: 16px;
  height: 16px;
}

/* 移除旧的按钮样式 */
.add-node-button,
.delete-node-button {
  display: none;
}

.node-title {
  flex: 1;
  min-width: 0;
  padding: 0 8px;
  line-height: 24px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>